export default "__VITE_ASSET__CkFAKvdg__"